module.exports = __webpack_public_path__ + "media/paws/paw-yellow-f094014c.svg";